import * as React from "react";
import styled from "styled-components";
import { CustomerDataFilter } from ".";

type Props = {
  customer: CustomerDataFilter;
};

const Wrapper = styled.div`
  display: inline-block;

  & .project {
    font-style: italic;
  }
`;

const CustomerFilterRow = ({ customer }: Props) => {
  return (
    <Wrapper>
      <span>{customer.name}</span>
      {customer.project && (
        <span className="project"> ({customer.project.name})</span>
      )}
    </Wrapper>
  );
};

export default CustomerFilterRow;
